"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValidationStrategy = void 0;
var AddressValidationStrategy;
(function (AddressValidationStrategy) {
    AddressValidationStrategy["Urgent"] = "urgent";
    AddressValidationStrategy["RestrictedAreaOrigin"] = "restrictedAreaOrigin";
    AddressValidationStrategy["RestrictedAreaDestination"] = "restrictedAreaDestination";
    AddressValidationStrategy["RestrictedAreaOriginAndDestination"] = "restrictedAreaOriginAndDestination";
    AddressValidationStrategy["NoValidate"] = "noValidate";
    AddressValidationStrategy["IsAirportOriginOrDestination"] = "isAirportOriginAndDestination";
})(AddressValidationStrategy || (exports.AddressValidationStrategy = AddressValidationStrategy = {}));
//# sourceMappingURL=address-validation-strategy.enum.js.map